import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { FilesService } from './../../../services/files.service';
import { FilesTickets } from './../../../domain/files';
import { SessionService } from './../../../../core/services/sessionService';
import { ToastrService } from 'ngx-toastr';
import { ModalDirective, ModalOptions } from 'angular-bootstrap-md';

@Component({
    selector: 'upload-file',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss']
})
export class UploadFileComponent{
    @Input('idReferente') idReferente : number;
    @Input('title') title: string;
    @Input('allowMultiple') allowMultiple: boolean;
    @Output('filesSaved') filesSavedList = new EventEmitter<Set<File>>();
    @Output('onLoad') onload = new EventEmitter<boolean>();
    @ViewChild('file') file;
    data : any;
    public files: Set<File> = new Set();
    public filesTickets =  new Array<FilesTickets>();
    progress;
    canBeClosed = true;
    showCancelButton = true;
    uploading = false;
    uploadSuccessful = false;
    multiple = this.allowMultiple ? 'multiple' : null;
    @ViewChild('modal') modal: ModalDirective;
  modalConfigDefaults: ModalOptions = {
      backdrop: false,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      animated: true
    };

    constructor(public filesServices: FilesService, sessionService: SessionService, private toastr: ToastrService) {
        this.data = sessionService.getSession();
    }


    addFiles() {
        this.file.nativeElement.click();
    }

    onFilesAdded() {
        const files: { [key: string]: File } = this.file.nativeElement.files;
        if(this.allowMultiple){
            for (let key in files) {
                if (!isNaN(parseInt(key))) {
                    this.filesTickets.push(new FilesTickets(files[key]));
                }
            }
        } else {
            this.filesTickets = new Array<FilesTickets>();
            this.filesTickets.push(new FilesTickets(files[0]));
        }
        this.onload.emit(true);
    }

    reset(){
        this.files.clear();
        this.filesTickets = [];
        this.file.nativeElement.value = "";
        this.onload.emit(false);
    }

    descripcionSinCargar(){
        return this.filesTickets.some(item => item.checkDescripcion());
    }
    formatoValido(){
        return this.filesTickets.some(item => item.formatValid());
    }

    guardar(){
        if(this.descripcionSinCargar() && this.formatoValido()){
            this.modal.show();
        }
        else {
            this.toastr.error('Debe cargar la descripción del adjunto para poder guardarlo (solo se aceptan letras, números y espacios) y que cumpla con el formato aceptado', 'Error');
        }
    }

    upload(){
            // set the component state to "uploading"
            this.uploading = true;

            // start the upload and save the progress map
            this.progress = this.filesServices.upload(this.filesTickets, this.data.id);

            // convert the progress map into an array
            let allProgressObservables = [];
            for (let key in this.progress) {
                allProgressObservables.push(this.progress[key].id);
            }
            
            // When all progress-observables are completed...
            forkJoin(allProgressObservables).subscribe(end => {

                // ... the upload was successful...
                this.uploadSuccessful = true;

                // ... and the component is no longer uploading
                this.uploading = false;
                this.filesSaved(end);

            });
    }
    filesSaved(end){
        this.filesSavedList.emit(end);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/filesDialog/dialog/dialog.component.ts